export default __webpack_public_path__ + "static/media/user.77d7ec1d.jpg";